import { NSARouterMakerProps, NSAHomePage } from "namirasoft-account-react";
import { JobArrangerLayout } from '../JobArrangerLayout';
import { JobArrangerMenus } from "../JobArrangerMenus";

export default function HomePage(props: NSARouterMakerProps) 
{
	return (
		<JobArrangerLayout {...props}
			action={{ menus: { "Store": [JobArrangerMenus.download()] } }}
		>
			<NSAHomePage
				{...props}
			/>
		</JobArrangerLayout>
	);
}